/**
 * @file 搜索栏已选 tag 溢出 tips 文案组件。
 * 由 `NewRegionSelect` 在 `enableSearchTagOverflowBubble === true` 时渲染。
 */
import React, { useRef, useMemo } from 'react';
import useIsTextOverflow from '@gp/components/EllipsisHover/_hooks/useIsTextOverflow';
import CommonBubble from '../CommonBubble';
import type { IExactOverflowSearchTagTextProps } from './type';
import { resolveListBubbleContent } from './util';

/**
 * 搜索栏已选 tag 文案：仅文本溢出时展示 Bubble tips。
 *
 * `displayText`（children）与 `rawText` 分离：前者为 tag 实际渲染（可含 `renderTag`），
 * 后者为纯字符串，供溢出检测与 tips 全文。
 *
 * @remarks
 * - 未溢出时 `CommonBubble` 的 `content` 为 `undefined`，不挂载浮层
 * - `bubbleProps` 来自 `overflowBubbleProps.searchTag`，业务可透传 `overlayClassName`、`placement` 等
 */
const ExactOverflowSearchTagText: React.FC<IExactOverflowSearchTagTextProps> = ({
  item,
  locale,
  rawText,
  children,
  bubbleProps,
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const isOverflow = useIsTextOverflow(textRef, { text: rawText });
  const bubbleContent = useMemo(
    () => resolveListBubbleContent(item, locale, isOverflow, rawText),
    [item, locale, isOverflow, rawText],
  );

  return (
    <CommonBubble content={bubbleContent} {...bubbleProps}>
      <div className="dbc-region-select-tag__bubble-trigger">
        <span ref={textRef} className="dbc-region-select-tag__text">
          {children}
        </span>
      </div>
    </CommonBubble>
  );
};

export default ExactOverflowSearchTagText;
